import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="update-datatable-listing"
export default class extends Controller {

  static values = {
    controllerName: String,
  }

  connect() {
    let datatableController = this.currentDatatableController
    // The partial is streamed into the global #datatable_list div, so the
    // target datatable may not be present on the current page (e.g. archiving
    // an event from its settings page).
    if (!datatableController) return

    let remainingRecords = datatableController.getCurrentPageRemainingRecords()
    let current_page = datatableController.currentPageNumber

    if (remainingRecords == 1 && current_page > 1) {
      datatableController.updatePageNumber(current_page - 1)
    } else {
      datatableController.updatePageNumber(current_page)
    }
  }

  get currentDatatableController() {
    let that = this
    return this.application.controllers.find(controller => {
      return controller.context.identifier === `${that.controllerNameValue}`;
    });
  }
}
